import axios from "axios";
import { resolveApiUrl } from "../assets/GlobalVariables";
import { getSessionId } from "./authService";

const BASE_PATH = "/api/agent/site-slider";

function resolvePath(path = "") {
  return resolveApiUrl(`${BASE_PATH}${path}`);
}

async function withSessionRequestConfig() {
  const sessionID = await getSessionId();
  if (!sessionID) {
    throw new Error("agent_site_slider_no_session");
  }
  const sid = String(sessionID).trim();
  return {
    headers: {
      "X-Session-ID": sid,
    },
    withCredentials: true,
    timeout: 30000,
    sid,
  };
}

export async function fetchAgentSiteSlider() {
  const cfg = await withSessionRequestConfig();
  const { data } = await axios.get(resolvePath(""), cfg);
  return Array.isArray(data?.items) ? data.items : [];
}

export async function uploadAgentSiteSliderImage(file) {
  const cfg = await withSessionRequestConfig();
  const form = new FormData();
  form.append("file", file);
  const { data } = await axios.post(resolvePath("/upload"), form, {
    ...cfg,
    headers: {
      ...cfg.headers,
      "Content-Type": "multipart/form-data",
    },
  });
  return data;
}

export async function createAgentSiteSliderItem(payload) {
  const cfg = await withSessionRequestConfig();
  const { data } = await axios.post(resolvePath(""), { ...payload, sessionID: cfg.sid }, cfg);
  return data;
}

export async function updateAgentSiteSliderItem(id, payload) {
  const cfg = await withSessionRequestConfig();
  const { data } = await axios.put(resolvePath(`/${id}`), { ...payload, sessionID: cfg.sid }, cfg);
  return data;
}

export async function deleteAgentSiteSliderItem(id) {
  const cfg = await withSessionRequestConfig();
  const { data } = await axios.delete(resolvePath(`/${id}`), cfg);
  return data;
}

export async function reorderAgentSiteSlider(ids) {
  const cfg = await withSessionRequestConfig();
  const { data } = await axios.post(resolvePath("/reorder"), { ids, sessionID: cfg.sid }, cfg);
  return Array.isArray(data?.items) ? data.items : [];
}
